class FeaturedIngredients extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  async initSwiper() {
    new Swiper(this.querySelector('.featured-ingredients__swiper'), {
      slidesPerView: 1.1,
      spaceBetween: 12,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 0,
          navigation: {
            nextEl: '.featured-ingredients__swiper-next',
            prevEl: '.featured-ingredients__swiper-prev',
          },
          pagination: false,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 0,
          navigation: {
            nextEl: '.featured-ingredients__swiper-next',
            prevEl: '.featured-ingredients__swiper-prev',
          },
        },
      },
    });
  }
}

customElements.define('featured-ingredients', FeaturedIngredients);
